import { CompetitionListFilter } from './components/competition-list-filter';
import { CompetitionListTable } from './components/competition-list-table';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Pagination } from '~/components/Pagination/Pagination';
import { useAuthentication } from '~/hooks/useAuthentication';
import { useFilterForm } from '~/hooks/useFilterForm';
import { useCompetitionListQuery } from '../queries';
import { Button } from '~/components/Button/Button';
import { Fragment } from 'react/jsx-runtime';
import { querySchema } from './query-schema';
import { Link } from 'react-router';

export function Page() {
  const { values } = useFilterForm(querySchema.parse);
  const { can } = useAuthentication();

  const { data, isLoading } = useCompetitionListQuery({
    state: values.group === 'ALL' ? undefined : values.group === 'COMPLETED' ? ['CLOSED'] : ['CREATED', 'PUBLISHED'],
    districts: values.districts?.length ? values.districts?.split(',').map(v => Number(v)) : undefined,
    category: values.category ? [values.category] : undefined,
    from_end_date: values.from_end_date,
    to_start_date: values.to_start_date,
    page_size: values.pageSize,
    ordering: values.ordering,
    page: values.pageIndex,
    search: values.search,
  });

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text="Tävlingskatalog" />

        {can('create-competition') && (
          <Link to="create">
            <Button type="button">Skapa tävling</Button>
          </Link>
        )}
      </PageLayout.Header>

      <PageLayout.Section>
        <CompetitionListFilter />
        <CompetitionListTable competitions={data?.results ?? []} isLoading={isLoading} />
        <Pagination count={data?.count} />
      </PageLayout.Section>
    </Fragment>
  );
}
